import { render, staticRenderFns } from "./teammanage.vue?vue&type=template&id=7872bdf2&lang=pug"
import script from "./teammanage.vue?vue&type=script&lang=js"
export * from "./teammanage.vue?vue&type=script&lang=js"
import style0 from "./teammanage.vue?vue&type=style&index=0&id=7872bdf2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports